import React, { useEffect, useRef, useState } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ConfirmDialog from './ConfirmDialog';
import { registerOdometerConfirm } from '../utils/odometer';

const initialState = {
  open: false,
  currentLabel: '',
  nextLabel: '',
  context: '',
};

export default function OdometerConfirmHost() {
  const resolverRef = useRef(null);
  const [dialogState, setDialogState] = useState(initialState);

  useEffect(() => {
    registerOdometerConfirm((payload) => new Promise((resolve) => {
      resolverRef.current = resolve;
      setDialogState({
        open: true,
        currentLabel: payload.currentLabel,
        nextLabel: payload.nextLabel,
        context: payload.context,
      });
    }));

    return () => {
      registerOdometerConfirm(null);
    };
  }, []);

  const closeWith = (value) => {
    const resolve = resolverRef.current;
    resolverRef.current = null;
    setDialogState(initialState);
    if (resolve) resolve(value);
  };

  return (
    <ConfirmDialog
      open={dialogState.open}
      title="Confirm Odometer Update"
      description={(
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Please confirm this mileage change before we update the vehicle record.
          </Typography>

          <Box
            sx={{
              p: 2,
              borderRadius: 3,
              background: 'linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%)',
              border: '1px solid #dbe7ff',
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5 }}>
              <SpeedIcon sx={{ color: '#1565c0' }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0f2747' }}>
                Vehicle mileage
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
              <Chip label={`Current: ${dialogState.currentLabel}`} sx={{ fontWeight: 700, bgcolor: '#ffffff' }} />
              <TrendingUpIcon sx={{ color: '#5c6bc0' }} />
              <Chip label={`New: ${dialogState.nextLabel}`} color="primary" sx={{ fontWeight: 700 }} />
            </Stack>
          </Box>

          <Typography variant="body2" color="text.secondary">
            This will {dialogState.context}.
          </Typography>
        </Stack>
      )}
      confirmText="Update Odometer"
      cancelText="Cancel"
      confirmColor="primary"
      onConfirm={() => closeWith(true)}
      onClose={() => closeWith(false)}
      icon={<SpeedIcon sx={{ color: '#1565c0' }} />}
    />
  );
}
